import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.company',
    modules: [
        R,
    ],
})
@Service('CompanyStore')
export default class Store extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('companies');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/company.js